// extracted by mini-css-extract-plugin
module.exports = {"input":"_2etUttR968Wi-V16cyiRvN"};